import { useAtomValue } from 'jotai';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { VEHICLE_STATUS_VALUES } from '@core/Services/Search/Search.constants';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';
import SelectionControls from '@gds/SelectionControls/SelectionControls';
import { useUpdateFilters } from '@search-filters/Hooks/UseUpdateFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import { trackFilterEvent } from '../../Filters.tracking';

export const IncludeSold = ({ strings }: FilterControlBaseProps) => {
  const filtersList = useAtomValue(filtersListAtom);
  const { updateFilters } = useUpdateFilters();
  const isChecked =
    getFilterFromArray('vehicle-status', filtersList)?.value === VEHICLE_STATUS_VALUES.includeSold;

  const handleChange = (eventTarget: EventTarget & HTMLInputElement) => {
    const filterValue = eventTarget.checked
      ? VEHICLE_STATUS_VALUES.includeSold
      : VEHICLE_STATUS_VALUES.excludeSold;
    updateFilters([{ id: 'vehicle-status', value: filterValue }]);

    const eventValue = filterValue === VEHICLE_STATUS_VALUES.includeSold ? 'true' : 'false';
    trackFilterEvent('vehicle-status', eventValue, filtersList);
  };

  return (
    <section>
      <SelectionControls
        checked={isChecked}
        label={strings.includeSoldInfoLine}
        onChange={e => handleChange(e.target as EventTarget & HTMLInputElement)}
        type="switch"
      />
    </section>
  );
};
